import React from 'react';
import PropTypes from 'prop-types';

import QuoteSOVButton from './quoteSOVButtons';
import { getPathVariables } from '../../misc';

import {
  DueMonthlyWrapper,
  DueNowWrapper,
  ButtonsWrapper,
  Button,
  Flex,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart,
  FractionalPart,
  Currency
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Desktop = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmitForApproval,
  hidePricing,
  isQuoteApproved
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      DUE_NOW,
      BEFORE_TAXES,
      DOWNLOAD_THE_QUOTE,
      PROCEED_WITH_THE_ORDER,
      saveAndContinueLater,
      sendToSRT,
      submitForApproval,
      continueButton
    }
  } = localizedStringsContext;

  const getFormattedPricing = pricing => {
    const newPricing = pricing.replace('$', '');
    const locale = getPathVariables(window.location.pathname)[0];
    return (
      <>
        <IntegralPart>
          {newPricing.split('.')[0]}
          <FractionalPart>
            {locale === 'fr-CA' ? ',' : '.'}
            {newPricing.split('.')[1]}
          </FractionalPart>
        </IntegralPart>
        <Currency style={{ order: locale === 'fr-CA' ? '3' : '-1' }}>
          $
        </Currency>
      </>
    );
  };

  return (
    <div id="footer-high">
      <>
        {!hidePricing && (
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(dueMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(dueNow)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
        )}

        {isOrderFulfillmentTeam ? (
          <QuoteSOVButton
            isFormTouched={isFormTouched}
            isFormValidated={isFormValidated}
            onDownloadClick={onDownloadClick}
            onProceedClick={onProceedClick}
            onValidateForm={onValidateForm}
          />
        ) : (
          <ButtonsWrapper>
            <Flex>
              {isFormValidated && !isVBP && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onDownloadClick(e)}
                    className="frg-button color-green"
                  >
                    <span>{DOWNLOAD_THE_QUOTE}</span>
                  </button>
                </Button>
              )}
              {!isSendToSRT && !isVBP && isFormValidated && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onProceedClick(e)}
                    className="frg-button color-purple"
                  >
                    <span>{PROCEED_WITH_THE_ORDER}</span>
                  </button>
                </Button>
              )}
              {isSendToSRT && !isVBP && isFormValidated && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSendToSRT(e)}
                    className="frg-button color-purple"
                  >
                    <span>{sendToSRT}</span>
                  </button>
                </Button>
              )}
              {!isFormValidated && !isVBP && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSaveAndExit(e)}
                    className="frg-button color-green"
                    disabled={!isFormTouched && !isQuoteApproved}
                  >
                    <span>{saveAndContinueLater}</span>
                  </button>
                </Button>
              )}
              {!isFormValidated && !isVBP && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onValidateForm(e)}
                    className="frg-button color-purple"
                    disabled={!isFormTouched && !isQuoteApproved}
                  >
                    <span>{continueButton}</span>
                  </button>
                </Button>
              )}
              {isFormValidated && isVBP && !isSalesSupport && (
                <Button>
                  <button
                    type="button"
                    onClick={e => onSubmitForApproval(e)}
                    className="frg-button color-green"
                  >
                    <span>{submitForApproval}</span>
                  </button>
                </Button>
              )}
            </Flex>
          </ButtonsWrapper>
        )}
      </>
    </div>
  );
};

Desktop.propTypes = {
  isVBP: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmitForApproval: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isQuoteApproved: PropTypes.bool.isRequired
};

export default Desktop;
